import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { DeclarationItem } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingDeclarations/DeclarationItem.js';
import { useConfig } from '../../../../../../components/HotelDetailsOverlay/context/Config.js';
import { useAmadeusRating } from '../../../../../../components/HotelDetailsOverlay/hooks/useAmadeusRating.js';
import { LabelSmallBold, LabelXSmall, Stack } from '../../../../../../primitives/index.js';
import { RatingScoreBar } from '../../../../../../primitives/Rating/index.js';
import { SPACING_SMALL, SPACING_XSMALL } from '../../../../../../utils/spacingLegacy.js';
export const RatingDeclarations = () => {
  const {
    t
  } = useTranslation();
  const formatScore = useAmadeusRating();
  const {
    amadeusRating: {
      scoreThresholds
    }
  } = useConfig();
  return _jsxs(Stack, {
    spacing: SPACING_SMALL,
    children: [_jsx(LabelSmallBold, {
      children: t('hotelDetailsOverlay:amadeusRatingSection.score.tooltipTitle')
    }), _jsx(Stack, {
      spacing: SPACING_XSMALL,
      children: Object.keys(scoreThresholds).map(key => {
        const {
          sentiment,
          scorePercentage,
          scoreDescription,
          scoreRangeMin,
          scoreRangeMax
        } = formatScore(scoreThresholds[key].min);
        return _jsxs(DeclarationItem, {
          children: [_jsx(LabelXSmall, {
            children: `${scoreRangeMin} - ${scoreRangeMax}`
          }), _jsx(RatingScoreBar, {
            sentiment: sentiment,
            percentage: scorePercentage
          }), _jsx(LabelXSmall, {
            children: scoreDescription
          })]
        }, key);
      })
    })]
  });
};